// A unique id per browser tab / page-load. Generated once when this module first loads, so it
// stays constant for the life of the tab and changes on reload or in a new tab.
//
// Shared by the Sentry setup (index.jsx) and the API client (api.js): the frontend fingerprints
// and tags its Sentry events with it, and sends it on every API request as `x-tab-session`, so
// the backend can tag its own Sentry events with the same id. That lets frontend and backend
// errors from one session be correlated across the two Sentry projects.
export const tabSessionId =
  (typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID()) ||
  `${Date.now()}-${Math.random().toString(36).slice(2)}`;
